module.exports = {"ADD":"Add","EDIT":"Edit","DELETE":"Delete","REMOVE":"Remove","VIEW":"View","UNLOCK":"Unlock"}